var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"law"},[_c('div',{staticClass:"auto_1280",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }